import { gql } from '@apollo/client'

export const FETCH_COACH_PROFILE = gql`
  query coachProfile($coachId: ID!) {
    coachProfile(coachId: $coachId) {
      id
      bio
      photo
      credentials
      fullName
      coachId
      specialties {
        key
        name
      }
      endDate
    }
  }
`
